var map = {
	"./aparthotelclub/ic_website_colored.png": 12622,
	"./beachful/ic_website_colored.png": 61687,
	"./castlepedia/ic_website_colored.png": 41437,
	"./cocktayl/ic_website_colored.png": 30296,
	"./ic_website_colored.png": 24830,
	"./luxresortclub/ic_website_colored.png": 9699,
	"./parkful/ic_website_colored.png": 52696,
	"./prefabworld/ic_website_colored.png": 58532,
	"./rooftopclub/ic_website_colored.png": 8480,
	"./spaclub/ic_website_colored.png": 89680,
	"./worldcasino/ic_website_colored.png": 79575,
	"./zoopedia/ic_website_colored.png": 55512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18552;